import HowWeAreDifferentPage from 'routes/HowWeAreDifferent'

export default function WebsiteHowWeAreDifferent() {
  return <HowWeAreDifferentPage />
}
